export default __webpack_public_path__ + "static/media/PAPAYA_LOGO.23bea0fc.svg";